import { Store } from 'laco'

import ClubService from 'Services/club'
import config from 'config'

import { toast } from 'react-toastify'
import CustomLinkService from 'Services/customlinks'

const ClubStore = new Store({
  clubs: [],
  selectedClub: undefined,
  loaded: false,
  previewImages: {},
  customLinks: {}
})

let isLoadingNextClubs = false

export const updateClubs = async () => {
  if (isLoadingNextClubs) return
  isLoadingNextClubs = true

  ClubStore.set(() => ({ loaded: false }))

  const clubs = await ClubService.list().catch(err => {
    toast.error(`Failed to load clients ${err.message ? `: ${err.message}` : ''}`)
  })

  isLoadingNextClubs = false

  if (!clubs.data) return

  ClubStore.set(() => ({ clubs: clubs.data, loaded: true }))
}

export const setSelection = async ({ clubId = -1, club = {} }) => {
  if (clubId !== -1) {
    const { selectedClub } = ClubStore.get()

    if (selectedClub?.clubId === clubId) return // Select the same club

    if (typeof clubId !== 'number' && clubId !== undefined) {
      console.error('The club selection must be undefined or a number')
      return
    }

    const resp = await ClubService.get({ id: clubId })
    const customLinks = (await CustomLinkService.get({ id: clubId })).data
    const { data } = resp

    club = { ...data, id: clubId, customLinks }
  }

  ClubStore.set(() => ({ selectedClub: club }))
}

export const getSelectedClub = async () => {
  const { selectedClub } = ClubStore.get()

  if (!selectedClub) return {}

  return selectedClub
}

export const getLogoURL = async () => {
  const { selectedClub, previewImages } = ClubStore.get()

  if (previewImages.imageHeader) {
    return `${previewImages.imageHeader}`
  }

  if (!selectedClub) return 'https://via.placeholder.com/180x180.png?text=No+Image+Found'

  const logoName = selectedClub.logo._text
  return `${config.api.getUrl()}/uploads/${logoName}`
}

export const getResourcePhotos = async (previewImages, setPreviewImages) => {
  const { selectedClub } = ClubStore.get()

  if (!selectedClub) return

  const { couponbtn } = selectedClub
  const { coupondata } = couponbtn

  const imageNames = [
    coupondata.image1._text,
    coupondata.image2._text,
    coupondata.image3._text,
    coupondata.image4._text,
    coupondata.image5._text,
    coupondata.image6._text,
    coupondata.image7._text
  ]

  const indxToImageLocation = ['image1', 'image2', 'image3', 'image4', 'image5', 'image6', 'image7']

  let photos = {}

  indxToImageLocation.forEach((loc, indx) => {
    photos = {
      ...photos,
      [loc]: {
        src: `${
          imageNames[indx] ? `${config.api.getUrl()}/uploads/resources/${imageNames[indx]}` : ''
        }`,
        uploaded: false
      }
    }
  })

  setPreviewImages(photos)
  return photos
}

export const getCustomLinks = async ({ ids = [] }) => {
  const { selectedClub, customLinks } = ClubStore.get()
  if (ids.length === 0) {
    if (!selectedClub) return
    const { data } = await ClubService.getCustomLinks({ id: selectedClub.id })
    if (data === customLinks) return
    ClubStore.set(() => ({ club: { ...selectedClub, customLinks: data } }))
    return data
  }
  const data = await CustomLinkService.getLinks({ ids })
  ClubStore.set(() => ({ club: { ...selectedClub, customLinks: data } }))
  return data
}

export const setPreviewImages = async (image, name) => {
  /* 
    Possible Image Locations
    couponbtn.coupondata.image1-6
    logo._text

    Names that we accept
    image1, image2, image3, image4, image5, image6 => Resource images
    imageHeader => Logo
  */
  const imageNames = [
    'image1',
    'image2',
    'image3',
    'image4',
    'image5',
    'image6',
    'image7',
    'imageHeader'
  ]

  if (!imageNames.includes(name))
    return console.error(
      `Can't set preview image of name ${name}. Please use: \n ${imageNames.join(', ')}`
    )

  const { previewImages } = ClubStore.get()

  const imageURL = URL.createObjectURL(image)
  ClubStore.set(() => ({ previewImages: { ...previewImages, [name]: { _text: imageURL } } }))
}

export const removeSelectedClub = async () => {
  ClubStore.set(() => ({ selectedClub: undefined }))
}

export default ClubStore
